<template>
    <div class="question">
        <div v-if="question.type === 'test'">
            <singleTest :question='question'></singleTest>
            <timer :timeLimit = "timeLimit"></timer>
        </div>
        <div v-if="question.type === 'freeword'">
            <freeword :question='question'></freeWord>
            <timer :timeLimit = "timeLimit"></timer>
        </div>
        <div v-if="question.type === 'multiTest'">
            <multiTest :question='question'></multiTest>
            <timer :timeLimit = "timeLimit"></timer>
        </div>
    </div>
</template>

<script>
import singleTest from '@/components/question/questionType/singleTest';
import freeWord from '@/components/question/questionType/freeWord';
import multiTest from '@/components/question/questionType/multiTest';
import timer from '@/components/tools/timer';
export default {
    data: () => {
        return {
            timeLimit: 0
        }   
    },
    props: ['question'],
    components: {
        'singleTest': singleTest,
        'timer' : timer,
        'freeword' : freeWord,
        'multiTest' : multiTest
    },
    created() {
       
        if(this.question['start_date'] !== undefined && this.question['start_date'] !== null){
            var diff =Math.floor(((Date.parse(this.question['start_date']) - Date.now()))/1000*(-1));
            this.timeLimit = Number(this.question['time_limit']) - Number(diff);
        } else {
            this.timeLimit = this.question['time_limit'];
            var startDateSaveData = {
                'session_questions_fk': this.question.session_questions_id
            }
            this.axios.put('/backend/web/start-question?access-token=' + this.$store.state.privateKey, startDateSaveData);
        }


    },
    beforeDestroy() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>